export const selectTariffsList = state => state.tariffs.listOfTariffs;

export const selectInvoiceData = state => state.tariffs.invoiceData;

export const selectTariffsLoading = state => state.tariffs.tariffsLoading;

export const selectInvoiceDataLoading = state => state.tariffs.invoiceDataLoading;

export const selectTariffsError = state => state.tariffs.error;

export const selectBalanceUsageDetails = state => state.tariffs.balanceUsageDetails;

export const selectServiceUsagePrices = state => state.tariffs.serviceUsagePrices;

export const selectBalanceUsageDetailsLoading = state => state.tariffs.balanceUsageDetailsLoading;
